import { gql } from '@apollo/client'
import { pick } from 'ramda'
import React from 'react'

import { accountsClient } from '../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../components/helpers/LazyAction'
import StatePresenter from '../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useUsersState = () => React.useContext(Context) || {}
export const useUsers = () => useUsersState()?.users || []

const QUERY = gql`
  query Users($page: Int, $limit: Int, $search: String, $filter: UserFilter) {
    users(page: $page, limit: $limit, search: $search, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      email
    }
  }
`

const UsersLoader = ({ children, search, filter, perPage: limit, uncontrolledChildren }) => {
  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      limit: limit || 24,
      search,
      sort: { field: 'NAME', type: 'ASC' },
      // TODO: Allow placeIds and checklistIds filter when segments are better defined
      filter: { ...pick(['profileIds'], filter || {}), ignoreSegments: true }
    },
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default UsersLoader
